import { useOrganization } from '@/contexts/OrganizationContext';

/**
 * Telas de análise (Métricas, WhatsApp Oficial, Saúde dos Números) são de
 * gestão: admin, manager e owner enxergam; rep não.
 *
 * Vive aqui, e não inline em cada tela, porque a mesma regra já é aplicada na
 * sidebar e agora também dentro de Configurações — a segunda cópia foi o sinal
 * de que precisava virar um lugar só. O papel vem da MEMBERSHIP da org corrente
 * (`OrganizationContext`), não de `profiles`: a mesma pessoa pode ser admin numa
 * org e rep em outra.
 *
 * `loading` é devolvido junto porque enquanto a org não carregou o papel é
 * indistinguível de "não tem permissão". Quem só esconde um item de menu pode
 * ignorar; quem REDIRECIONA precisa esperar, senão chuta um manager legítimo
 * para fora da tela no primeiro render.
 */
export function useCanAccessAnalytics(): { canAccessAnalytics: boolean; loading: boolean } {
  const { currentOrg, loading } = useOrganization();
  return {
    canAccessAnalytics: Boolean(
      currentOrg &&
        (currentOrg.role === 'admin' || currentOrg.role === 'manager' || currentOrg.role === 'owner'),
    ),
    loading,
  };
}
